export default {
  "pl": {
    "project": {
      "actions": {
        "addProjectMaintainer": "Dodaj opiekuna projektu",
        "add_as_partner": "Dodaj jako partnera",
        "add_as_partner_description": "Czy na pewno chcesz, żeby {partner} został(a) partnerem tego projektu?",
        "add_project_partner": "Dodaj partnera projektu",
        "changeProjectLogin": "Zmień obraz projektu",
        "changeProjectLogo": "Zmień logo projektu",
        "finishRequest": "Wysłać prośbę",
        "follow": "Obserwuj",
        "giveAccess": "Udziel dostępu",
        "maintainerAdd": "Dodaj opiekuna projektu",
        "maintainerAddDescription": "Czy na pewno chcesz, żeby {maintainer} uzyskał(a) dostęp do tego projektu?",
        "maintainerRemove": "Usuń opiekuna projektu",
        "maintainerRemoveDescription": "Czy na pewno chcesz, żeby {maintainer} utracił(a) dostęp do tego projektu?",
        "new": "Nowy projekt",
        "optional_information": "Opcjonalna Informacja",
        "remove_partner": "Usuń partnera: {partner}",
        "remove_project_partner": "Usuń partnera projektu",
        "remove_project_partner_description": "Czy na pewno chcesz usunąć partnera {partner} z partnerów projektu?",
        "selectOption": "Wybierz opcję"
      },
      "attributes": {
        "address": "Adres",
        "currency": "Waluta",
        "delivery_date_actual": "Oczekiwana data ukończenia",
        "delivery_date_contractual": "Umowna data ukończenia",
        "description": "Opis",
        "ft_decisions": "Decyzje",
        "internal_note": "Notatka do użytku wewnętrznego",
        "measurement": "Jednostka miary",
        "name": "Nazwa",
        "picture_url": "Obraz projektu",
        "quotity_total": "Całkowita suma projektu",
        "skip_building": "Ukryj budynek",
        "skip_lot": "Ukryj działkę",
        "skip_phase": "Ukryj fazę",
        "start_date": "Data rozpoczęcia",
        "units_count": "Liczba utworzonych jednostek",
        "units_count_max": "Maksymalna liczba jednostek",
        "vat_percentage": "VAT (%)",
        "website_url": "Adres URL strony internetowej"
      },
      "import": {
        "add": "+ Dodaj",
        "add_instead": "Właściwie to chcę dodać {levels}",
        "building": "budynek",
        "buildings": "Budynki",
        "changed_mind": "zmieniłem zdanie",
        "create_new": "Utwórz nowy {typ}",
        "download_template": "Pobierz szablon importu",
        "drop_or_upload": "Upuść szablon tutaj lub kliknij, aby przesłać",
        "fill_unit_info": "Wypełnij szablon informacjami o jednostce",
        "fix_file_upload": "Rozwiąż problemy i prześlij plik ponownie.</br>Istniejące jednostki nie zostaną usunięte, ale zostaną zaktualizowane, jeśli coś się zmieniło w pliku dla tej jednostki od ostatniego przesłania.",
        "for": "dla",
        "import_column_title": "Czy chcesz dodać {column_type}?",
        "import_units": "Importuj jednostki dla",
        "lot": "działka",
        "lots": "wiele",
        "no": "nie",
        "noLevels": "Nie {levels}",
        "phase": "faza",
        "phases": "fazy",
        "plot": "działka",
        "select_level_above": "Wybierz {level}",
        "start_upload": "Zacznij przesyłać",
        "step": "Krok",
        "unit_info": "Będziesz mógł importować jednostki po utworzeniu projektu",
        "unit_limit": "Chcesz zaimportować więcej jednostek niż jest to dozwolone. Usuń jednostkę {exceeded_by} lub poproś nas o zwiększenie liczby dozwolonych jednostek",
        "units": "jednostki",
        "upload_filled_template": "Prześlij wypełniony szablon",
        "upload_new_file": "Prześlij nowy plik",
        "upload_units": "Prześlij jednostki",
        "uploaded_file": "Przesłany plik",
        "validations_failed": "Niektóre walidacje nie powiodły się",
        "yes": "tak"
      },
      "labels": {
        "checkLevels": "Sprawdź poziomy, które chcesz dodać:",
        "companyInfo": "Informacje o firmie",
        "companyNameTitle": "Nazwa firmy",
        "congratulationsNewProject": "Gratulujemy nowego projektu",
        "download_export": "Pobierz moje dane do eksportu",
        "downloading_export": "Pobieranie",
        "endsOn": "Koniec: {enddate}",
        "export_expiration": "Twoje dane do eksportu są gotowe do pobrania. Będą dostępne do godz. {time}",
        "export_explanation": "Poproś o eksport wszystkich swoich danych, w tym rozmów i dokumentów.",
        "export_file": "Eksportuj mój plik",
        "export_notification_snack": "Przygotowywanie twojego pliku może zająć do kilku minut. Gdy plik będzie gotowy do pobrania, otrzymasz powiadomienie.",
        "export_prepared": "Twoje dane do eksportu wkrótce będą gotowe do pobrania.",
        "export_preparing": "Przygotowywanie danych do eksportu",
        "finalSteps": "Ostatnie kroki",
        "follow": "Zacznij obserwować projekt {project}, aby otrzymywać powiadomienia.",
        "followedProjects": "Moje projekty",
        "following": "Obserwowane",
        "general": "Ogólne",
        "importContacts": "Tak, chciałbym zaimportować kontakty klientów",
        "importInformationSubtitle": "Zamiast dodawać spacje i kontakt pojedynczo, możemy pomóc Ci w imporcie pliku CSV. Zaznacz poniższe pola, a członek zespołu Ziggu skontaktuje się z Tobą.",
        "importInformationTitle": "Zaimportować informacje?",
        "importSpaces": "Tak, chciałbym zaimportować miejsca parkingowe i magazynowe",
        "importUnits": "Tak, chciałbym zaimportować jednostki i ich informacje",
        "internal": "Wewnętrzne",
        "levels": "Struktura projektu",
        "nameTitle": "Nazwa projektu?",
        "noAccess": "Nie masz dostępu do tego projektu",
        "noFollowedProjects": "Kliknij ikonę powiadomień, aby zacząć obserwować projekt.",
        "optional_information": "Informacje opcjonalne",
        "optional_information_subtitle": "Czy jest coś jeszcze, czym chciałbyś się z nami podzielić?",
        "otherProjects": "Inne projekty",
        "partner_invitation_notice": "Partner {partner} nie został jeszcze zaproszony. Zaproszenie zostanie wysłane, gdy partner {partner} zostanie dodany do partnerów projektu.",
        "pendingProjects": "Projekt {first_project_name} został poproszony i jest obecnie konfigurowany przez Ziggu | Zażądano {count} projektów i są one obecnie konfigurowane przez Ziggu",
        "permission_partner_project": "Wybierz partnera, aby w łatwy sposób udostępniać mu dokumenty i oferty.",
        "permissionsOwnerOnly": "Tylko członkowie zespołu pełniący rolę właściciela mogą dodawać nowych opiekunów projektu",
        "permissionsRoleMaintainer": "Wybierz członka zespołu pełniącego rolę opiekuna, aby udzielić mu dostępu do projektu.",
        "project": "Projekt: {project}",
        "projectMaintainers": "Opiekunowie projektu",
        "projectStructure": "Struktura projektu",
        "projectStructureSubtitle": "Masz teraz możliwość dodania 3 dodatkowych poziomów, aby lepiej zorganizować swoje jednostki.</br>Przejrzyjmy każdy z nich, krok po kroku.",
        "projectStructureSubtitleOld": "Struktura projektu jest definiowana raz na początku projektu.",
        "project_label": "Projekt",
        "project_partners": "Partnerzy projektu",
        "projects": "Wszystkie projekty",
        "remove_project_partner_prohibited": "Partner {partner} został dodany do decyzji w projekcie i nie można go usunąć z partnerów projektu.",
        "remove_project_partner_prohibited_label": "Nie można usunąć partnera projektu",
        "spaces": "Przestrzenie",
        "startsOn": "Początek: {startdate}",
        "step1Info": "Omówmy kilka szczegółów na początek.",
        "step1Title": "Gratulujemy nowego projektu!",
        "step2Info": "Do jakiej firmy możemy skierować fakturę?",
        "step2Title": "Szczegóły do faktury",
        "step3Title": "Potrzebujesz poziomów pośrednich?",
        "step4Info": "Co się potem dzieje? Ziggu skonfiguruje {project} w ciągu 3 do 5 dni roboczych. Otrzymasz powiadomienie, gdy wszystko będzie gotowe.",
        "unFollow": "Nie otrzymuj powiadomień dotyczących projektu: {project}.",
        "underConstruction": "W budowie",
        "unitsActiveRemaining": "DOSTĘPNE JEDNOSTKI",
        "unitsAllotted": "PRZYDZIELONE JEDNOSTKI",
        "unitsCountSubtitle": "Ile jednostek?",
        "upsell": {
          "project_partner_cta": "Skontaktuj się z nami, aby dowiedzieć się jak!",
          "project_partner_info": "Skontaktuj się z nami, aby dowiedzieć się jak!"
        }
      },
      "messages": {
        "units_count_max": "Jeśli chcesz utworzyć więcej jednostek, skontaktuj się z nami, korzystając z przycisku czatu."
      },
      "navigation": {
        "backToProjects": "Powrót do projektów"
      },
      "notifications": {
        "pictureChangedSuccessfully": "Obraz został zaktualizowany. Zmiany będą widoczne w ciągu godziny."
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Nie masz dostępu do żadnych projektów. Poproś członka zespołu pełniącego rolę właściciela, aby udzielił ci dostępu.",
            "title": "Brak projektów"
          }
        },
        "partners": {
          "noProjectSubtitle": "Otrzymasz powiadomienie, kiedy zostanie do ciebie przypisany nowy projekt",
          "noProjectTitle": "Brak projektu"
        }
      },
      "tooltip": {
        "hasNoActiveUnits": "Nie ma aktywnych jednostek",
        "turnOffNotifications": "Wyłącz powiadomienia dotyczące projektu: {project}",
        "turnOnNotifications": "Włącz powiadomienia dotyczące projektu: {project}"
      },
      "validation": {
        "addressInformationRequired": "Wymagane informacje adresowe",
        "companyNeedName": "Wymagana nazwa firmy",
        "companyNeedVatNumber": "Wymagany numer VAT",
        "dateAfter": "Data musi być późniejsza niż data rozpoczęcia",
        "lessThanOrEqual": "Liczba musi być mniejsza lub równa {max_number}",
        "maxLength": "Nazwa może składać się z maksymalnie {length} znaków",
        "nameAlreadyTaken": "Nazwa tego projektu jest już zajęta",
        "needName": "Należy podać tytuł",
        "needNumber": "Należy podać liczbę (np. 850)",
        "needUnitsCount": "Liczba jednostek jest wymagana"
      }
    }
  }
}
